import BreadcrumbView from "../common/breadcrumb/breadcrumb.html";
import NotificationsByPersonListView from "./notifications_by_person-list.html";


angular.module("notifications_by_person", [])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('notifications_by_person', {
                url: "/notifications_by_person",
                abstract: true,
                controller: "BreadcrumbCtrl",
                template: BreadcrumbView,
            })
            .state('notifications_by_person.list', {
                url: "/list",
                controller: "NotificationsByPersonListCtrl",
                template: NotificationsByPersonListView,
                cache: false,
                data: { pageTitle: 'Historico' },
                requiredPermission: ["NOTIFICATIONS_READ"]
            })
        ;
    }])
;